import { render, staticRenderFns } from "./RegistrationNameTitleFormGroup.vue?vue&type=template&id=12299fad&"
import script from "./RegistrationNameTitleFormGroup.vue?vue&type=script&lang=js&"
export * from "./RegistrationNameTitleFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/registration.locale?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cforms%5Cregistration%5CRegistrationNameTitleFormGroup.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/common.locale?vue&type=custom&index=1&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Cforms%5Cregistration%5CRegistrationNameTitleFormGroup.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports